var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7431 46.0502L25.5361 40.2002V83.4272C25.5365 83.8968 25.6294 84.3617 25.8095 84.7954C25.9896 85.2292 26.2533 85.6231 26.5856 85.9549C26.918 86.2867 27.3124 86.5498 27.7464 86.7291C28.1804 86.9085 28.6455 87.0006 29.1151 87.0002H86.4151C86.8852 87.0014 87.351 86.9099 87.7857 86.7309C88.2204 86.5519 88.6155 86.2889 88.9485 85.9571C89.2815 85.6252 89.5458 85.2309 89.7262 84.7968C89.9067 84.3627 89.9997 83.8973 90.0001 83.4272V67.5002L58.7431 46.0502Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7431 9H29.1151C28.6455 8.99961 28.1804 9.09171 27.7464 9.27106C27.3124 9.45041 26.918 9.71348 26.5856 10.0453C26.2533 10.377 25.9896 10.771 25.8095 11.2048C25.6294 11.6385 25.5365 12.1034 25.5361 12.573V28.5L58.7431 48L76.3261 53.85L90.0001 48V28.5L58.7431 9Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5361 28.5H58.7431V48H25.5361V28.5Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.3021 24.6001H25.5361V73.3501H49.3021C50.2491 73.3454 51.1561 72.9677 51.8266 72.2989C52.4971 71.6301 52.877 70.7241 52.8841 69.7771V28.1731C52.877 27.2261 52.4971 26.3201 51.8266 25.6513C51.1561 24.9825 50.2491 24.6048 49.3021 24.6001Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.3491 26.5498H25.5361V75.2998H47.3491C48.2961 75.2951 49.2031 74.9174 49.8736 74.2486C50.5441 73.5798 50.924 72.6738 50.9311 71.7268V30.1228C50.924 29.1758 50.5441 28.2698 49.8736 27.601C49.2031 26.9322 48.2961 26.5545 47.3491 26.5498Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.3491 26.5498H25.5361V71.3998H47.3491C48.2961 71.3951 49.2031 71.0174 49.8736 70.3486C50.5441 69.6798 50.924 68.7738 50.9311 67.8268V30.1228C50.924 29.1758 50.5441 28.2698 49.8736 27.601C49.2031 26.9322 48.2961 26.5545 47.3491 26.5498Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.3961 26.5498H25.5361V71.3998H45.3961C46.3431 71.3951 47.2501 71.0174 47.9206 70.3486C48.5911 69.6798 48.971 68.7738 48.9781 67.8268V30.1228C48.971 29.1758 48.5911 28.2698 47.9206 27.601C47.2501 26.9322 46.3431 26.5545 45.3961 26.5498Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.582 26.5498H45.396C46.3447 26.549 47.2549 26.9249 47.9266 27.5949C48.5982 28.2649 48.9764 29.1741 48.978 30.1228V65.8768C48.9764 66.8255 48.5982 67.7347 47.9266 68.4047C47.2549 69.0747 46.3447 69.4506 45.396 69.4498H9.582C9.11214 69.4506 8.64673 69.3588 8.21237 69.1796C7.77802 69.0004 7.38323 68.7374 7.05057 68.4056C6.71791 68.0738 6.4539 67.6797 6.27364 67.2458C6.09338 66.8118 6.00039 66.3467 6 65.8768V30.1228C6.00039 29.6529 6.09338 29.1878 6.27364 28.7539C6.4539 28.32 6.71791 27.9258 7.05057 27.594C7.38323 27.2622 7.77802 26.9992 8.21237 26.82C8.64673 26.6408 9.11214 26.549 9.582 26.5498Z",
    fill: "url(#paint0_linear_4164_5431)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 59.6189L24.6326 47.9669L17.7326 36.3809H23.2736L27.0386 43.7999C27.3866 44.5019 27.6386 45.0239 27.7526 45.3719H27.8036C28.0496 44.8079 28.3106 44.2649 28.5836 43.7339L32.6096 36.3929H37.7096L30.6326 47.9129L37.8896 59.6279H32.4626L28.1126 51.4949C27.9106 51.1452 27.739 50.7788 27.5996 50.3999H27.5276C27.4008 50.7691 27.2316 51.1225 27.0236 51.4529L22.5446 59.6189H17.0996Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4182 9.00001H58.7432V28.5H90.0002V12.573C89.9998 12.1031 89.9068 11.638 89.7265 11.2041C89.5463 10.7702 89.2823 10.376 88.9496 10.0442C88.6169 9.71238 88.2222 9.44937 87.7878 9.2702C87.3534 9.09103 86.888 8.99922 86.4182 9.00001Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7432 48H90.0002V67.5H58.7432V48Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4164_5431",
    x1: 13.482,
    y1: 23.7418,
    x2: 41.496,
    y2: 72.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.8d7a3c8cbf43bce0037ac2eb42d4dbda.svg";
export { ForwardRef as ReactComponent };